<div class="app-messages">
  <div class="app-messages-header">
    <h2 nz-typography translate>messages.title</h2>
    <a class="app-messages-header-new-message" (click)="startMessageThread()">
      <app-image name="add"></app-image>
      <span class="app-messages-header-new-message-text icon-text" translate>messages.newMessage</span>
    </a>
  </div>

  <app-alert></app-alert>

  <nz-card class="app-messages-content light">
    @if (messageThreads$ | async; as messageThreads) { @if (messageThreads.length > 0) {
    <div class="app-messages-content-inbox">
      @if (isMessageThreadSelectionVisible()) {
      <app-message-thread-list
        size="default"
        [messageThreads]="messageThreads"
        [selectedMessageThreadId]="selectedMessageThreadId"
        (messageSelected)="selectMessageThread($event)"
      ></app-message-thread-list>
      } @if (isMessageThreadDetailsVisible()) { @if (selectedMessageThreadId) {
      <app-message-thread-details [id]="selectedMessageThreadId"></app-message-thread-details>
      } @else {
      <div class="app-messages-content-inbox-select-thread">
        <app-image name="inbox"></app-image>
        <p translate>messages.select</p>
      </div>
      } }
    </div>
    } @else {
    <div class="app-messages-empty-inbox">
      <app-empty-inbox [textCode]="'messages.empty'"></app-empty-inbox>
    </div>
    } }
  </nz-card>
</div>
